import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'mdn-polyfills/Element.prototype.closest';
import 'flickity-as-nav-for';
import Headroom from 'headroom.js';
import zenscroll from 'zenscroll';
import Flickity from 'flickity-bg-lazyload';
import Splide from '@splidejs/splide';
import Utils from './classes/Utils';
import Init from './classes/Init';

const siteFunctions = {
  lazyload__ready() {
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.lazyClass = 'js-load';
    window.lazySizesConfig.loadingClass = 'loading';
    window.lazySizesConfig.loadedClass = 'loaded';
    window.lazySizesConfig.loadMode = 1;
  },
  lazySizes__ready() {
    document.addEventListener('lazybeforeunveil', e => {
      const bg = e.target.getAttribute('data-bg');
      if (bg) {
        e.target.style.backgroundImage = `url(${bg})`;
      }
    });
  },
  animateIn__ready() {
    const animateElements = Array.from(document.querySelectorAll('.js-animate'));

    animateElements.forEach(element => {
      const animateElementIn = () => {
        if (Utils.isInViewport(element)) {
          Utils.removeClass(element, 'inactive');
        }
      };
      Utils.animationFrames(animateElementIn);
    });
  },
  slider__ready() {
    if (document.querySelector('.splide')) {
      const elms = document.getElementsByClassName('splide');
      for (let i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
          arrows: false,
          type: 'fade',
          rewind: true,
          autoplay: true,
          interval: 4000,
          speed: 1200,
          pagination: false
        }).mount();
      }
    }
  },
  paint__ready() {
    document.getElementsByTagName('body')[0].classList.add('is-active');
  },
  scrollToNextElement__ready() {
    const scrollCta = Array.from(document.querySelectorAll('.js-scroll-to'));

    scrollCta.forEach(element => {
      element.addEventListener('click', e => {
        e.preventDefault();
        const target = element.closest('section').nextElementSibling;
        zenscroll.to(target);
      });
    });
  },
  header__ready() {
    const def = x => typeof x !== 'undefined' && x !== null;
    const header = document.querySelector('.js-header');
    const offsetElement = document.querySelector('.js-header-offset');
    const offsetHeight = def(offsetElement) ? offsetElement.scrollHeight : -100;
    const headroom = new Headroom(header, {
      offset: offsetHeight,
      classes: {
        initial: 'c-header',
        pinned: 'c-header--pinned',
        unpinned: 'c-header--unpinned',
        top: 'c-header--top',
        notTop: 'c-header--fixed',
        bottom: 'c-header--bottom',
        notBottom: 'c-header--notBottom'
      }
    });

    headroom.init();
  },
  searchInputPlaceholder__ready() {
    /*eslint-disable */
    const Defaults = $.fn.select2.amd.require("select2/defaults");
    $.extend(Defaults.defaults, {
      searchInputPlaceholder: "",
    });
    const SearchDropdown = $.fn.select2.amd.require("select2/dropdown/search");
    const _renderSearchDropdown = SearchDropdown.prototype.render;
    SearchDropdown.prototype.render = function (decorated) {
      // invoke parent method
      const $rendered = _renderSearchDropdown.apply(
        this,
        Array.prototype.slice.apply(arguments)
      );
      this.$search.attr(
        "placeholder",
        this.options.get("searchInputPlaceholder")
      );
      return $rendered;
    };
    /* eslint-enable */
  },
  select__ready() {
    $('.gfield_select').each(function() {
      if ($(this)[0].length >= 8) {
        $(this).select2({
          width: '100%',
          searchInputPlaceholder: 'Search...'
        });
      }
    });
  },
  schoolType__ready() {
    if ($('.js-select-type').length > 0) {
      const displayActive = index => {
        $(`.js-select-type-target[data-index="${index.value}"]`).removeClass('d-none');
      };

      const hideInactive = el => {
        el.each(function() {
          $(this).addClass('d-none');
        });
      };

      $('.js-select-type').on('change', function() {
        hideInactive($('.js-select-type-target'));
        displayActive(this);
      });
    }
  },
  productSlider__ready() {
    const def = x => typeof x !== 'undefined' && x !== null;

    const controls = document.querySelector('.js-gallery-nav');
    const gallery = document.querySelector('.js-gallery-slider');

    if (def(gallery) && def(controls)) {
      new Flickity('.js-gallery-slider', {
        bgLazyLoad: true,
        pageDots: false,
        wrapAround: true
      });

      new Flickity('.js-gallery-nav', {
        asNavFor: '.js-gallery-slider',
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });
    }
  },
  mobileNav__ready() {
    const hamburger = document.querySelector('.c-hamburger');
    const menu = document.querySelector('.c-navigation-mobile');

    const def = x => typeof x !== 'undefined' && x !== null;

    if (def(hamburger)) {
      hamburger.addEventListener('click', () => {
        if (menu.classList.contains('c-navigation-mobile--open')) {
          menu.classList.remove('c-navigation-mobile--open');
          hamburger.classList.remove('c-hamburger--open');
          document.documentElement.classList.remove('no-scroll');
        } else {
          menu.classList.add('c-navigation-mobile--open');
          hamburger.classList.add('c-hamburger--open');
          document.documentElement.classList.add('no-scroll');
        }
      });
    }
  },
  payOnlineFormSubmit__ready() {
    const form = document.querySelector('.js-pay-online-form');
    const donationAmountField = document.querySelector('.js-donation-amount');

    if (form === null || donationAmountField === null) return;

    // Pass donation amount to dataLayer for tag manager
    form.addEventListener(
      'submit',
      () => {
        const donationAmount = donationAmountField.querySelector('input').value;
        if (donationAmount > 0) {
          dataLayer.push({
            payInDonationAmount: donationAmount
          });
        }
      },
      false
    );
  }
};

window.functionCore = new Init(siteFunctions);
